import React, { useState, useEffect, useCallback } from 'react';
import MentionsTab     from './tabs/MentionsTab';
import TopicsTab       from './tabs/TopicsTab';
import InfluencersTab  from './tabs/InfluencersTab';
import AssistantTab    from './tabs/AssistantTab';
import OverviewTab     from './tabs/OverviewTab';
import ThreatMonitorTab from './tabs/ThreatMonitorTab';
import SettingsTab      from './tabs/SettingsTab';
import CommonButton     from '../../Components/CommonButton';
import PageHeading      from '../../Components/PageHeading';
import { getUserFlags } from '../../helper';
import './brand-mentions.scss';

const ALL_TABS = [
    {
        key: 'overview', label: 'Overview', component: OverviewTab,
        subtitle: 'Your Brand Risk at a glance: what needs attention, mention volume and sentiment, where the conversation happens, topics, threats and takedowns.',
    },
    {
        key: 'mentions', label: 'Mentions', component: MentionsTab,
        subtitle: 'Every post about your brand across social platforms, news and forums. Filter, search and summarise them with FORESEE AI.',
    },
    {
        key: 'topics', label: 'Topic Analysis', component: TopicsTab,
        subtitle: 'Discover the most important topics and trends in your brand coverage. Check sentiment + engagement + share-of-voice per topic.',
    },
    {
        key: 'influencers', label: 'Influencers & Sources', component: InfluencersTab,
        subtitle: "Who's driving the conversation, and where. Risk-tagged sources pin to the top, so your watchlist setup pays off here.",
    },
    {
        key: 'threat_monitor', label: 'Threat Monitor', component: ThreatMonitorTab,
    },
    {
        key: 'assistant', label: 'AI Brand Assistant', component: AssistantTab,
        subtitle: "Ask FORESEE AI about your brand's mentions, sentiment, narratives, sources and influencers.",
    },
    {
        key: 'settings', label: 'Settings', component: SettingsTab,
        subtitle: 'Configure watchlists, mention anchors, privacy, retention, paging, the logo registry and takedowns, and review the audit log. Admin only.',
    },
];

function BrandMentions() {
    const flags = getUserFlags();
    const isAdmin = flags.is_org_admin === true || flags.is_platform_admin === true;
    const TABS = ALL_TABS.filter(t => {
        if (t.adminOnly) return isAdmin;
        return true;
    });
    const [tab, setTab] = useState(ALL_TABS[0].key);
    const activeTab = TABS.find(t => t.key === tab) || TABS[0];
    const Active = activeTab.component;
    const [liveSubtitles, setLiveSubtitles] = useState({});
    const activeKey = activeTab.key;
    const reportSubtitle = useCallback(text => setLiveSubtitles(prev => (
        prev[activeKey] === text ? prev : { ...prev, [activeKey]: text }
    )), [activeKey]);
    const subtitle = activeTab.subtitle ?? liveSubtitles[activeKey];
    // Empty-state CTAs in child tabs dispatch this event to navigate
    // the user to e.g. the Settings tab (so they can configure watchlists
    // before findings populate).
    useEffect(() => {
        const handler = (e) => {
            const target = e?.detail?.tab;
            if (target && TABS.some(t => t.key === target)) setTab(target);
        };
        window.addEventListener('bm-tab-switch', handler);
        return () => window.removeEventListener('bm-tab-switch', handler);
    }, []);
    return (
        <div className="bm_root bm_root--base cmn_elevated_card">
            <div className="bm_topbar">
                <PageHeading title={activeTab.label} subtitle={subtitle} className="bm_topbar_heading" />
                <div className="bm_tabs">
                    {TABS.map(t => (
                        <CommonButton
                            key={t.key}
                            text={t.label}
                            variant={tab === t.key ? 'primary' : 'white'}
                            className="bm_tab"
                            onClick={() => setTab(t.key)}
                        />
                    ))}
                </div>
            </div>
            <div className="bm_tab_body">
                <Active onSubtitle={reportSubtitle} />
            </div>
        </div>
    );
}

export default BrandMentions;
